import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { OnSiteMessagingOrchestratorInterface } from '@central-products/interface-on-site-messaging-orchestrator';
import canShowMessage from './canShowMessage';

var OnSiteMessagingOrchestrator = /*#__PURE__*/function (_OnSiteMessagingOrche) {
  _inherits(OnSiteMessagingOrchestrator, _OnSiteMessagingOrche);

  var _super = _createSuper(OnSiteMessagingOrchestrator);

  function OnSiteMessagingOrchestrator() {
    var _this;

    _classCallCheck(this, OnSiteMessagingOrchestrator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "messageCallback", void 0);

    return _this;
  }

  _createClass(OnSiteMessagingOrchestrator, [{
    key: "onMessageRequested",
    value: function onMessageRequested(callback) {
      this.messageCallback = callback; // tslint:disable-next-line:no-empty

      return function () {};
    }
  }, {
    key: "requestMessage",
    value: function requestMessage(message) {
      if (this.messageCallback && canShowMessage()) {
        this.messageCallback(message);
      }
    }
  }]);

  return OnSiteMessagingOrchestrator;
}(OnSiteMessagingOrchestratorInterface);

export default OnSiteMessagingOrchestrator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9PblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3IudHMiXSwibmFtZXMiOlsiT25TaXRlTWVzc2FnaW5nT3JjaGVzdHJhdG9ySW50ZXJmYWNlIiwiY2FuU2hvd01lc3NhZ2UiLCJPblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3IiLCJjYWxsYmFjayIsIm1lc3NhZ2VDYWxsYmFjayIsIm1lc3NhZ2UiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLFNBQ0VBLG9DQURGLFFBSU8sNERBSlA7QUFLQSxPQUFPQyxjQUFQLE1BQTJCLGtCQUEzQjs7SUFFTUMsMkI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3VDQUdzQkMsUSxFQUFnQztBQUN4RCxXQUFLQyxlQUFMLEdBQXVCRCxRQUF2QixDQUR3RCxDQUd4RDs7QUFDQSxhQUFPLFlBQU0sQ0FBRSxDQUFmO0FBQ0Q7OzttQ0FFcUJFLE8sRUFBd0I7QUFDNUMsVUFBSSxLQUFLRCxlQUFMLElBQXdCSCxjQUFjLEVBQTFDLEVBQThDO0FBQzVDLGFBQUtHLGVBQUwsQ0FBcUJDLE9BQXJCO0FBQ0Q7QUFDRjs7OztFQWR1Q0wsb0M7O0FBaUIxQyxlQUFlRSwyQkFBZiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7XG4gIE9uU2l0ZU1lc3NhZ2luZ09yY2hlc3RyYXRvckludGVyZmFjZSxcbiAgTWVzc2FnZSxcbiAgQ2FsbGJhY2ssXG59IGZyb20gJ0BjZW50cmFsLXByb2R1Y3RzL2ludGVyZmFjZS1vbi1zaXRlLW1lc3NhZ2luZy1vcmNoZXN0cmF0b3InO1xuaW1wb3J0IGNhblNob3dNZXNzYWdlIGZyb20gJy4vY2FuU2hvd01lc3NhZ2UnO1xuXG5jbGFzcyBPblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3IgZXh0ZW5kcyBPblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3JJbnRlcmZhY2Uge1xuICBwcml2YXRlIG1lc3NhZ2VDYWxsYmFjaz86IENhbGxiYWNrO1xuXG4gIHB1YmxpYyBvbk1lc3NhZ2VSZXF1ZXN0ZWQoY2FsbGJhY2s6IENhbGxiYWNrKTogKCkgPT4gdm9pZCB7XG4gICAgdGhpcy5tZXNzYWdlQ2FsbGJhY2sgPSBjYWxsYmFjaztcblxuICAgIC8vIHRzbGludDpkaXNhYmxlLW5leHQtbGluZTpuby1lbXB0eVxuICAgIHJldHVybiAoKSA9PiB7fTtcbiAgfVxuXG4gIHB1YmxpYyByZXF1ZXN0TWVzc2FnZShtZXNzYWdlOiBNZXNzYWdlKTogdm9pZCB7XG4gICAgaWYgKHRoaXMubWVzc2FnZUNhbGxiYWNrICYmIGNhblNob3dNZXNzYWdlKCkpIHtcbiAgICAgIHRoaXMubWVzc2FnZUNhbGxiYWNrKG1lc3NhZ2UpO1xuICAgIH1cbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBPblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3I7XG4iXX0=